// Общий контракт свойств пунктов бокового меню.
export const sidebarItemProps = {
  collapsed: { type: Boolean, default: false },
  activeItem: { type: String, required: true },
  canSeePage: { type: Function, required: true },
  showNewBadge: { type: Boolean, default: false },
};

// Прокидывает стандартные события навигации из пункта в контейнер меню.
export function useSidebarItem(emit) {
  const navigate = (event, routeName) =>
    emit("navigate", event, routeName);

  const handleMiddleClick = (event, routeName) =>
    emit("middle-click", event, routeName);

  const showContextMenu = (event, routeName) =>
    emit("context-menu", event, routeName);

  return { navigate, handleMiddleClick, showContextMenu };
}
